import type { ChatMessage } from '../state/reducer';

/**
 * Whether an assistant bubble should render an avatar. Only the first bubble
 * of a consecutive assistant run shows the avatar; subsequent ones align to
 * the same indent without repeating it (ChatGPT/Claude-style grouping).
 */
export function showsAvatar(messages: ChatMessage[], index: number): boolean {
  const cur = messages[index];
  if (!cur || cur.role !== 'assistant') return false;
  const prev = messages[index - 1];
  return !prev || prev.role !== 'assistant';
}
